module.exports = __webpack_public_path__ + "img/JE.74048269.svg";